<template>
  <fb-form-body>
    <RecipeStep
        style="margin-top: 26px"
        :active="stepActive"
        @change="handleSetStep"
        :stepList="stepList"/>

    <div style="margin-top: 24px">
      <keep-alive>
        <component
            @translate="$refs.translate.handleShow()"
            @next="handleNext"
            @lastStep="handleLastStep"
            @save="handleSave"
            @edit="handleEditRecipe"
            @preview="handlePreviewRecipe"
            @finish="handleFinish"
            @submit="handleSubmit"
            status="edit"
            :load="load"
            :recipeCode="code"
            :is="currentView[stepActive]"></component>
      </keep-alive>
    </div>

    <translate-select ref="translate" @confirm="handleSave"  />
  </fb-form-body>
</template>

<script>
import RecipeStep from "../../components/recipe-step/RecipeStep";
import RecipePhotoForm from "../../components/recipe-photo-form/RecipePhotoForm";
import FoodForm from '../../components/food-form/FoodForm';
import IntroductionForm from '../../components/introduction-form/IntroductionForm';
import RecipeCookingSteps from "../../components/recipe-cooking-steps/RecipeCookingSteps";
import ToolForm from '../../components/tool-form/ToolForm';
import UseTime from '../../components/use-time/UseTime';
import RecipeNutritionForm from "../../components/recipe-nutrition-form/RecipeNutritionForm";
import RecipeInfoForm from "../../components/recipe-info-form/RecipeInfoForm";
import RecipeFinishForm from "../../components/recipe-finish-form/RecipeFinishForm";
import {debounce, handleScrollToTop} from "../../utlis/utlis";
import TranslateSelect from "../../components/translate/TranslateSelect.vue";

const routerName = ["category-set-add", "tag-add"];

export default {
  name: "recipeEdit",
  components: {
    TranslateSelect,
    RecipeStep,
    RecipePhotoForm,
    FoodForm,
    IntroductionForm,
    RecipeCookingSteps,
    ToolForm,
    UseTime,
    RecipeNutritionForm,
    RecipeInfoForm,
    RecipeFinishForm
  },
  data() {
    return {
      stepActive: 0,
      currentView: {
        '0': 'RecipePhotoForm',
        '1': 'FoodForm',
        '2': 'IntroductionForm',
        '3': 'RecipeCookingSteps',
        '4': 'ToolForm',
        '5': 'UseTime',
        '6': 'RecipeNutritionForm',
        '7': 'RecipeInfoForm',
        '8': 'RecipeFinishForm',
      },
      stepList: [
        {title: '名字与图片', icon: 'camera'},
        {title: '准备食材', icon: 'food'},
        {title: '做饭介绍', icon: 'introduction'},
        {title: '烹饪步骤', icon: 'step'},
        {title: '所需工具', icon: 'tool'},
        {title: '花费时间', icon: 'time'},
        {title: '营养成分', icon: 'element'},
        {title: '更多信息', icon: 'info'},
        {title: '完成', icon: 'finish'},
      ],
      api: {
        detail: this.$api.recipe.detail,
        update: this.$api.recipe.update,
        submit: this.$api.recipe.submit,
        save: this.$api.recipe.save,
      },
      formData: {},
      load: false,
      code: '',
      recipeInfo: {}
    }
  },
  methods: {
    // 设置步骤
    handleSetStep(index) {
      if(index > 0) {
        let errorText = this.handleValidateStepOne();
        if(errorText) {
          this.$message.error(errorText);
          return;
        }
      }
      this.stepActive = index;
    },

    // 校验步骤一
    handleValidateStepOne()  {
      let {lang, recipeLang, supportLangList, type} = this.$store.state.recipe;
      if(!type) return this.$t("lang.请选择食谱类型");
      if(!supportLangList.length) return this.$t("lang.请选择支持语言");
      if(!lang) return this.$t("lang.请选择主语言");
      if(!recipeLang[lang] || !recipeLang[lang].name) return this.$t("lang.请输入主语言食谱名称");
    },

    // 预览食谱
    handlePreviewRecipe() {
      const {modifyEditionCode: recipeEditionCode, number} = this.recipeInfo;
      this.$router.push({
        path: '/preview-detail',
        query: {
          recipeEditionCode,
          number
        }
      })
    },
    handleNext() {
      let index = this.stepActive + 1;
      this.handleSetStep(index);
      handleScrollToTop()
    },

    handleLastStep() {
      this.stepActive--;
      handleScrollToTop();
    },

    // 返回流程1
    handleEditRecipe() {
      this.stepActive = 0;
      handleScrollToTop();
    },

    handleGetDetail() {
      const vm = this;
      vm.$http.get(vm.api.detail, {params: vm.$route.query}).then(res => {
        if (res.data.status != 200) {
          vm.$message.error(res.data.desc);
          return;
        }
        let recipe = res.data.data['recipe'];
        recipe.type = recipe.type || "SOUP";
        this.$store.commit("CHANGE_RECIPE", {...recipe});
        vm.load = true;
        vm.formData = recipe;
      })
    },

    handleSave: debounce(function () {
      const vm = this;
      let data = this.handleCheckWorkMode();
      if (!data) return;
      this.$customLoading.showLoading(vm);
      vm.$http.post(vm.api.save, data).then(res => {
        this.$customLoading.hideLoading();
        if (res.data.status != 200) {
          vm.$message.error(res.data.desc);
          return;
        }
        vm.$message.success(vm.$t('lang.保存成功'));
      }).catch(err => {
        this.$customLoading.hideLoading();
        let res = err.response;
        this.$message.error(res.data.desc || res.data.message || "请求失败");
      });
    }, 3000, true),

    handleFinish: debounce(function () {
      const vm = this;
      let data = this.handleCheckWorkMode();
      if (!data) return;
      this.$customLoading.showLoading(vm);
      vm.$http.post(vm.api.update, data).then(res => {
        this.$customLoading.hideLoading();
        if (res.data.status != 200) {
          vm.$message.error(res.data.desc);
          return;
        }
        vm.$message.success(res.data.desc);
        vm.stepActive++;
        vm.code = res.data.data.code;
        vm.recipeInfo = res.data.data.recipe;
      }).catch(err => {
        this.$customLoading.hideLoading();
        let res = err.response;
        this.$message.error(res.data.desc || res.data.message || "请求失败");
      });
    }, 3000, true),

    handleSubmit: debounce(function () {
      const vm = this;
      this.$customLoading.showLoading(vm);
      vm.$http.get(vm.api.submit, {params: {code: vm.code}}).then(res => {
        this.$customLoading.hideLoading();
        if (res.data.status != 200) {
          vm.$message.error(res.data.desc);
          return;
        }
        vm.$message.success(vm.$t('lang.提交成功'));
        vm.$router.back();
      })
    }, 3000, true),


    handleFormatData() {
      let recipe = JSON.parse(JSON.stringify(this.$store.state.recipe));
      recipe['code'] = this.$route.query.code;
      return recipe;
    },

    // 校验工作模式必填
    handleCheckWorkMode() {
      let data = this.handleFormatData();
      let index = data.cookingStepList.findIndex(i => !i.workMode);
      if(!data.photo) {
        this.$message.error(this.$t('lang.请上传食谱图片'));
        return;
      }

      const {portionSizeList} = data;
      const portionSizeItem = portionSizeList[0];
      if(!portionSizeItem || !portionSizeItem.portionSize || !portionSizeItem.portionSize[data.lang]) {
        this.$message.error(this.$t('lang.请填写份量'));
        return;
      }

      if (index != -1) {
        this.$message.error(this.$t('lang.工作模式不能为空'));
        return null
      }

      if(!data.products.length) {
        this.$message.error(this.$t('lang.请选择型号（机型）'));
        return null
      }

      if(!data.difficultyLevel) {
        this.$message.error(this.$t('lang.请勾选难易度'));
        return;
      }


      return data;
    }
  },
  created() {
    this.handleGetDetail();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$store.commit("CHANGE_KEEP_ALIVE_INCLUDE", {type: "add", value: "recipeEdit"})
    });
  },
  beforeRouteLeave(to, from, next) {
    if(!routerName.includes(to.name)) {
      this.$store.commit("CHANGE_KEEP_ALIVE_INCLUDE", {type: "remove", value: "recipeEdit"})
    }
    next();
  },
  beforeDestroy() {
    this.$store.commit("CLEAR_RECIPE");
  }
}
</script>

<style scoped>

</style>
